import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PilotHero } from '@/components/landing/pilot-hero'
import { LogoMarquee } from '@/components/landing/logo-marquee'
import { PilotIntro } from '@/components/landing/pilot-intro'
import { PilotSteps } from '@/components/landing/pilot-steps'
import { FullServiceSection } from '@/components/landing/full-service-section'
import { TestimonialsSlider } from '@/components/landing/testimonials-slider'
import { NumbersSection } from '@/components/landing/numbers-section'
import { CtaSection } from '@/components/landing/cta-section'

const Pilot: FC = (): ReactNode => {
    return (
        <Layout launcher>
            <Seo
                title='Pilot'
                description='FlowCraft Pilot links your apps and uses AI to make them work together. Show Pilot your work and it turns the routine into workflows that run on their own, no engineers required.'
            />

            <PilotHero />

            <LogoMarquee />

            <PilotIntro />

            <PilotSteps />

            <FullServiceSection />

            <TestimonialsSlider />

            <NumbersSection />

            <CtaSection
                title='Connect every tool.'
                accent='Automate every handoff.'
                actions={[
                    { label: 'Get started', variant: 'primary', intent: 'start' },
                    { label: 'Learn more', variant: 'secondary', href: '/full-service' }
                ]}
            />
        </Layout>
    )
}

export default Pilot
